module.exports = __webpack_public_path__ + "img/autospin_btn.05999fec.png";